<template>
  <div>
    <div>
      <vs-row
        vs-type="flex"
        class="mb-4"
        vs-justify="flex-end"
        vs-align="center"
        vs-w="12"
      >
        <vs-col
          size="small"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="flex-end"
          vs-w="12"
        >
          <el-button
            class="mx-2"
            plain
            @click="filtrarOrdenarPorPrioridade()"
            title="Ordenar por prioridade (Nível 3 > Nível 2 > Nível 1)"
            type="danger"
            size="small"
          >
            !
          </el-button>
          <vs-input
            class="mx-2"
            type="date"
            size="small"
            label="Data"
            v-model="filtro.data"
          ></vs-input>
          <div class="mx-2" style="display: flex; align-items: flex-end; gap: 4px;">
            <el-button plain size="small" @click="irParaData(-1)">Ontem</el-button>
            <el-button plain size="small" @click="irParaData(0)">Hoje</el-button>
            <el-button plain size="small" @click="irParaData(1)">Amanhã</el-button>
          </div>
          <span
            v-if="isPastDate"
            class="mx-2"
            style="color: #b45309; font-weight: 600; align-self: flex-end; margin-bottom: 8px;"
          >
            Somente leitura (histórico)
          </span>
          <vs-input
            class="mx-2"
            type="number"
            size="small"
            label="Qtd. Técnicos"
            v-model="filtro.tecnicos_exec"
          ></vs-input>
          <vs-input
            class="mx-2"
            type="number"
            size="small"
            min="0"
            label="Qtd. Carros"
            v-model="filtro.carros"
          ></vs-input>

          <div class="mx-2">
            <vs-input
              label="Hora marcada"
              name="hora_marcada"
              v-model="filtro.horario"
              v-mask="'##:00'"
              max="24"
              size="small"
              type="datetime"
              placeholder="00:00"
              class="inputx w-full"
            />
          </div>
          <div class="mx-2">
            <label style="color: black; font-size: 0.85rem">Turnos</label>
            <br />
            <el-select
              filterable
              multiple
              collapse-tags
              clearable
              size="small"
              v-model="filtro.turnos"
            >
              <el-option
                v-for="turno in turnos"
                class="select-info"
                :value="turno.id"
                :label="turno.nome"
                :key="turno.id"
              ></el-option>
            </el-select>
          </div>
          <div class="mx-2">
            <label style="color: black; font-size: 0.85rem">Zona</label>
            <br />
            <el-select filterable clearable size="small" v-model="filtro.zona">
              <el-option
                v-for="zona in zonas"
                class="select-info"
                :value="zona.id"
                :label="zona.nome"
                :key="zona.id"
              ></el-option>
            </el-select>
          </div>
          <div class="mx-2">
            <label style="color: black; font-size: 0.85rem"
              >Tipo de Controle</label
            >
            <br />
            <el-select
              filterable
              clearable
              size="small"
              v-model="filtro.controle"
            >
              <el-option
                v-for="controle in controles"
                class="select-info"
                :value="controle.id"
                :label="controle.nome"
                :key="controle.id"
              ></el-option>
            </el-select>
          </div>
          <div class="mx-2">
            <label style="color: black; font-size: 0.85rem"
              >Tipo de Serviço</label
            >
            <br />
            <el-select
              filterable
              clearable
              size="small"
              v-model="filtro.tipo_servico"
            >
              <el-option
                v-for="tipo in tipos_servico"
                class="select-info"
                :value="tipo.id"
                :label="tipo.nome"
                :key="tipo.id"
              ></el-option>
            </el-select>
          </div>
          <div class="mx-2">
            <vs-input
              label="Nº Contrato"
              size="small"
              type="number"
              min="1"
              v-model="filtro.id_contrato"
              placeholder="ID"
              class="inputx"
              style="width: 100px"
            />
          </div>
          <div class="mx-2">
            <vs-input
              label="Nº Serviço"
              size="small"
              type="number"
              min="1"
              v-model="filtro.id_servico"
              placeholder="OS"
              class="inputx"
              style="width: 100px"
            />
          </div>
          <el-button
            class="mx-2"
            plain
            :disabled="blockButton"
            @click="filtrar()"
            type="primary"
            size="small"
            >Filtrar</el-button
          >
        </vs-col>
      </vs-row>
    </div>
    <vs-row vs-type="flex" vs-w="12">
      <vs-col
        vs-w="2"
        class="px-2"
        :class="{ 'highlight-rota-col': highlightRotas }"
      >
        <rotaListaOsAssoc
          :filtro="filtro"
          :painelRotasTick="painelRotasTick"
          :historicoRotas="isPastDate ? historicoRotas : null"
          @rotaEmit="rotaEmit"
          :blocked="JSON.stringify(osRota) !== JSON.stringify(osRotaOriginal)"
          @update="rotaSelecionada"
        />
      </vs-col>
      <vs-col vs-w="6" class="px-2">
        <div>
          <vx-card style="background-color: #000a12">
            <vs-row
              vs-w="12"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-col
                vs-w="9"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    SERVIÇOS PENDENTES:
                    {{ osAssociar.length }}
                  </h5>
                </div>
              </vs-col>
              <vs-col
                vs-w="3"
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
              >
                <vs-button
                  v-if="$atividades.podeExportar('rota')"
                  color="success"
                  type="relief"
                  size="small"
                  :disabled="blockButton"
                  @click="exportToExcel()"
                  >EXCEL</vs-button
                >
              </vs-col>
            </vs-row>
          </vx-card>
          <perfect-scrollbar
            class="scroll-os-assoc"
            @ps-y-reach-end="showMoreOs2Assoc()"
          >
            <div
              id="osAssociar"
              class="vs-con-loading__container"
              style="position: relative"
            >
              <!-- Aviso: selecionar rota antes de arrastar (só exibe quando há serviços na lista) -->
              <div
                v-if="rota.id == null && osAssociar.length > 0"
                class="rota-nao-selecionada-aviso"
              >
                <vs-icon
                  icon="info"
                  size="small"
                  style="margin-right: 6px; vertical-align: middle"
                />
                Selecione uma <strong class="mx-1"> rota </strong> na coluna ao
                lado antes de arrastar serviços.
              </div>
              <div v-if="!osAssociar.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>
              <draggable
                :disabled="
                  !$atividades.permissoes.includes(8) || rota.id == null || isPastDate
                "
                v-model="osAssociarLista"
                group="lev"
                :class="rota.id == null ? 'drag-blocked' : 'draggable-source'"
                @start="onDragStart"
                @end="onDragEnd"
              >
                <div
                  v-for="data in osAssociarLista"
                  :key="data.id"
                  class="mx-2"
                  :title="
                    rota.id == null
                      ? 'Selecione uma rota primeiro para poder arrastar este serviço'
                      : ''
                  "
                  @mousedown="rota.id == null ? flashRotas() : null"
                >
                  <vx-card
                    class="mr-10 my-3 os-card overflow-hidden"
                    :style="
                      data.confirmado > 0
                        ? data.confirmado == 1
                          ? ''
                          : 'background-color:#cbdef7'
                        : 'background-color: #fae1e1'
                    "
                  >
                    <template slot="no-body">
                      <div class="item-details px-2">
                        <div class="my-1">
                          <div class="w-full">
                            <vs-col vs-w="8">
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  <b>
                                    {{
                                      data.remarcado > 0
                                        ? data.data_remarcacao
                                        : data.data_competencia
                                    }}
                                  </b>
                                  &nbsp;-&nbsp; Horas:
                                  <b>{{ data.horas_exec }}</b>
                                  &nbsp;-&nbsp;Técnicos:
                                  <b>{{ data.tecnicos_exec }}</b>
                                  &nbsp;-&nbsp;
                                  <b style="color: black">
                                    {{ data.controle }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <div class="visualizar-cliente-link">
                                  <VisualizarCliente
                                    @update="filtrar()"
                                    :id_cliente="data.id_cliente"
                                    :nomeCliente="data.nomeCliente"
                                  />
                                </div>

                                <span class="item-description text-md">
                                  &nbsp;&nbsp;-&nbsp;Cidade:
                                  <b>{{ data.nomeCidade }}</b>
                                  &nbsp;-&nbsp;Bairro:
                                  <b>{{ data.nomeBairro }}</b>
                                </span>
                              </vs-col>

                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-md">
                                  Contrato
                                  <b>
                                    <a
                                      target="_blank"
                                      :href="'/contrato?id=' + data.id_contrato"
                                      style="color: darkblue; cursor: pointer"
                                      >{{ data.id_contrato }}</a
                                    >
                                  </b>
                                  - Serviço
                                  <b>{{ data.id }} - {{ data.tipo }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                v-if="data.obs"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Obs:
                                  <b>{{ data.obs ? data.obs : "Sem obs" }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span
                                  class="item-description text-sm"
                                  v-if="data.pessoa_confirmacao"
                                >
                                  Pessoa confirmação:
                                  <b>{{ data.pessoa_confirmacao }}</b>
                                </span>
                              </vs-col>
                            </vs-col>
                            <vs-col
                              vs-w="4"
                              vs-type="flex"
                              vs-justify="flex-end"
                              vs-align="flex-start"
                            >
                              <div class="os-badges-col">
                                <!-- Executado -->
                                <span
                                  v-if="data.executado > 0"
                                  class="os-badge"
                                  :class="
                                    data.executado == 1
                                      ? 'badge-success'
                                      : 'badge-danger'
                                  "
                                >
                                  <feather-icon
                                    :icon="
                                      data.executado == 1
                                        ? 'CheckCircleIcon'
                                        : 'XCircleIcon'
                                    "
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{
                                    data.executado == 1
                                      ? "Executado"
                                      : "Não Exec."
                                  }}
                                </span>

                                <!-- Prioridade -->
                                <template
                                  v-for="op in [
                                    getOsPrioridade(data.id_nivel_prioridade),
                                  ]"
                                >
                                  <span
                                    :key="'prio-' + data.id"
                                    v-if="op"
                                    class="os-badge"
                                    :class="'badge-priority-' + op.variant"
                                    :title="op.title"
                                  >
                                    <feather-icon
                                      :icon="op.icon"
                                      :svgClasses="'w-3 h-3'"
                                    />
                                    {{ op.label }}
                                  </span>
                                </template>

                                <!-- Horário / Turno -->
                                <span class="os-badge badge-warning">
                                  <feather-icon
                                    icon="ClockIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{
                                    data.hora_marcada
                                      ? data.hora_marcada
                                      : data.turno
                                  }}
                                </span>

                                <!-- Escada -->
                                <span
                                  v-if="data.escada > 0"
                                  class="os-badge badge-escada"
                                  title="Serviço com Escada"
                                >
                                  <feather-icon
                                    icon="TrendingUpIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  Escada
                                </span>
                                <!-- FOG -->
                                <span
                                  v-if="data.fog > 0"
                                  class="os-badge badge-fog"
                                  title="Serviço com FOG"
                                >
                                  <feather-icon
                                    icon="WindIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  FOG
                                </span>
                                <!-- UBV -->
                                <span
                                  v-if="data.ubv > 0"
                                  class="os-badge badge-ubv"
                                  title="Serviço com UBV (Ultra Baixo Volume)"
                                >
                                  <feather-icon
                                    icon="DropletIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  UBV
                                </span>

                                <!-- Carros -->
                                <span
                                  v-if="data.carros > 0"
                                  class="os-badge badge-dark"
                                  title="Quantidade de carros"
                                >
                                  <feather-icon
                                    icon="TruckIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{ data.carros }}
                                  {{ data.carros == 1 ? "carro" : "carros" }}
                                </span>

                                <!-- Zona -->
                                <span
                                  v-if="data.nomeZona"
                                  class="os-badge badge-success"
                                  title="Zona"
                                >
                                  <feather-icon
                                    icon="MapPinIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{ data.nomeZona }}
                                </span>
                              </div>
                            </vs-col>
                          </div>
                        </div>
                      </div>
                    </template>
                  </vx-card>
                </div>
              </draggable>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="4" class="px-2">
        <div>
          <vx-card card-background="#021a33" :key="reRender">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="6"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    {{
                      rota.nome == null
                        ? "Selecione..."
                        : rota.nome + ": " + osRota.length
                    }}
                  </h5>
                </div>
              </vs-col>
              <vs-col
                vs-w="6"
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
              >
                <div v-if="!isTransferMode">
                  <el-popover placement="bottom" width="150" trigger="click">
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                      <vs-button
                        :disabled="JSON.stringify(osRota) == JSON.stringify(osRotaOriginal) || !$atividades.permissoes.includes(8) || isPastDate"
                        color="success"
                        size="small"
                        @click="osAssociarRota()"
                      >ASSOCIAR</vs-button>
                      <vs-button
                        :disabled="!(osRota.length > 0) || !$atividades.permissoes.includes(8) || isPastDate"
                        color="danger"
                        size="small"
                        @click="osRota = []"
                      >Limpar</vs-button>
                      <vs-button
                        :disabled="!(osRota.length > 0) || !$atividades.permissoes.includes(8) || isPastDate"
                        color="warning"
                        size="small"
                        @click="isTransferMode = true"
                      >Transferir</vs-button>
                    </div>
                    <vs-button slot="reference" color="primary" type="flat" class="p-2">
                      <i class="material-icons" style="font-size: 1.5rem;">more_vert</i>
                    </vs-button>
                  </el-popover>
                </div>
                <div v-else style="display: flex; gap: 8px; align-items: center;">
                  <vs-button
                    color="danger"
                    size="small"
                    @click="cancelTransferMode()"
                  >CANCELAR</vs-button>
                  <vs-button
                    color="warning"
                    size="small"
                    style="white-space: nowrap; width: auto;"
                    @click="selectAllTransfer()"
                  >SELEC. TODOS</vs-button>
                  <vs-button
                    color="success"
                    size="small"
                    style="white-space: nowrap; width: auto;"
                    @click="openDestinationModal()"
                  >SELEC. DESTINO</vs-button>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
          <VuePerfectScrollbar
            class="scroll-os-assoc"
            :settings="settings"
            style="background-color: #ebebeb"
          >
            <div id="osRota" class="vs-con-loading__container">
              <div v-if="!osRota.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>
              <draggable
                v-if="rota.nome != null"
                :disabled="isPastDate"
                v-model="osRota"
                group="lev"
                class="draggable-target"
                :class="{ 'dragging-over': isDragging }"
              >
                <div v-for="data in osRota" :key="data.id" class="mx-2">
                  <div :class="isTransferMode ? 'flex items-center' : ''">
                    <vs-checkbox 
                      v-if="isTransferMode && data.executado == null"
                      v-model="selectedOsToTransfer"
                      :vs-value="data.id"
                      class="mr-2"
                    />
                    <vx-card
                      class="my-3 os-card overflow-hidden"
                      :class="isTransferMode ? 'w-full' : 'mr-10'"
                      :style="
                        data.confirmado > 0
                          ? data.confirmado == 1
                            ? ''
                            : 'background-color:#cbdef7'
                          : 'background-color: #fae1e1'
                      "
                    >
                      <template slot="no-body">
                      <div class="item-details px-2">
                        <div class="my-1">
                          <div class="w-full">
                            <vs-col vs-w="8">
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <div>
                                  <span class="item-description text-sm">
                                    <b>
                                      {{
                                        data.remarcado > 0
                                          ? data.data_remarcacao
                                          : data.data_competencia
                                      }}
                                    </b>
                                    &nbsp;-&nbsp;Horas:
                                    <b>{{ data.horas_exec }}</b>
                                    &nbsp;-&nbsp;Técnicos:
                                    <b>{{ data.tecnicos_exec }}</b>
                                    &nbsp;-&nbsp;
                                    <b style="color: black">
                                      {{ data.controle }}
                                    </b>
                                  </span>
                                </div>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <div>
                                  <VisualizarCliente
                                    @update="filtrar()"
                                    :id_cliente="data.id_cliente"
                                    :nomeCliente="data.nomeCliente"
                                  />
                                </div>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-md">
                                  Cidade:
                                  <b>{{ data.nomeCidade }}</b>
                                  &nbsp;-&nbsp;Bairro:
                                  <b>{{ data.nomeBairro }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Contrato
                                  <b>
                                    <a
                                      target="_blank"
                                      :href="'/contrato?id=' + data.id_contrato"
                                      style="color: darkblue; cursor: pointer"
                                      >{{ data.id_contrato }}</a
                                    >
                                  </b>
                                  - Serviço
                                  <b>{{ data.id }} - {{ data.tipo }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                v-if="data.obs"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Obs:
                                  <b>{{ data.obs ? data.obs : "Sem obs" }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span
                                  class="item-description text-sm"
                                  v-if="data.pessoa_confirmacao"
                                >
                                  Pessoa confirmação:
                                  <b>{{ data.pessoa_confirmacao }}</b>
                                </span>
                              </vs-col>
                            </vs-col>
                            <vs-col
                              vs-w="4"
                              vs-type="flex"
                              vs-justify="flex-end"
                              vs-align="flex-start"
                            >
                              <div class="os-badges-col">
                                <!-- Executado -->
                                <span
                                  v-if="data.executado > 0"
                                  class="os-badge"
                                  :class="
                                    data.executado == 1
                                      ? 'badge-success'
                                      : 'badge-danger'
                                  "
                                >
                                  <feather-icon
                                    :icon="
                                      data.executado == 1
                                        ? 'CheckCircleIcon'
                                        : 'XCircleIcon'
                                    "
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{
                                    data.executado == 1
                                      ? "Executado"
                                      : "Não Exec."
                                  }}
                                </span>

                                <!-- Horário / Turno -->
                                <span class="os-badge badge-warning">
                                  <feather-icon
                                    icon="ClockIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{
                                    data.hora_marcada
                                      ? data.hora_marcada
                                      : data.turno
                                  }}
                                </span>

                                <!-- Escada -->
                                <span
                                  v-if="data.escada > 0"
                                  class="os-badge badge-escada"
                                  title="Serviço com Escada"
                                >
                                  <feather-icon
                                    icon="TrendingUpIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  Escada
                                </span>
                                <!-- FOG -->
                                <span
                                  v-if="data.fog > 0"
                                  class="os-badge badge-fog"
                                  title="Serviço com FOG"
                                >
                                  <feather-icon
                                    icon="WindIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  FOG
                                </span>
                                <!-- UBV -->
                                <span
                                  v-if="data.ubv > 0"
                                  class="os-badge badge-ubv"
                                  title="Serviço com UBV (Ultra Baixo Volume)"
                                >
                                  <feather-icon
                                    icon="DropletIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  UBV
                                </span>

                                <!-- Carros -->
                                <span
                                  v-if="data.carros > 0"
                                  class="os-badge badge-dark"
                                  title="Quantidade de carros"
                                >
                                  <feather-icon
                                    icon="TruckIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{ data.carros }}
                                  {{ data.carros == 1 ? "carro" : "carros" }}
                                </span>

                                <!-- Zona -->
                                <span
                                  v-if="data.nomeZona"
                                  class="os-badge badge-success"
                                  title="Zona"
                                >
                                  <feather-icon
                                    icon="MapPinIcon"
                                    :svgClasses="'w-3 h-3'"
                                  />
                                  {{ data.nomeZona }}
                                </span>
                              </div>
                            </vs-col>
                          </div>
                        </div>
                      </div>
                    </template>
                  </vx-card>
                  </div>
                </div>
              </draggable>
            </div>
          </VuePerfectScrollbar>
        </div>
      </vs-col>
    </vs-row>

    <!-- Modal Transferir OS -->
    <vs-popup
      title="Selecione a Rota Destino"
      :active.sync="modalTransferirVisivel"
      class="modal-transferir-os"
    >
      <div class="mb-4">
        <p class="mb-2">Escolha uma rota para transferir as <b>{{ selectedOsToTransfer.length }}</b> OS selecionadas:</p>
        
        <vs-input
          class="w-full mb-4"
          icon="search"
          placeholder="Buscar rota destino..."
          v-model="buscaRotaDestino"
        />

        <div class="rotas-destino-grid" style="max-height: 400px; overflow-y: auto;">
          <div 
            v-for="r in rotasLista.filter(x => {
              if (x.id === rota.id) return false;
              if (!buscaRotaDestino) return true;
              const busca = buscaRotaDestino.toLowerCase();
              const nomeMatch = x.nome && x.nome.toLowerCase().includes(busca);
              const idMatch = x.id && x.id.toString().includes(buscaRotaDestino);
              const textoResp = x.id_tecnico_responsavel ? (x.nome_tecnico_responsavel || 'Técnico ' + x.id_tecnico_responsavel) : 'Sem responsável';
              const respMatch = textoResp.toLowerCase().includes(busca);
              return nomeMatch || idMatch || respMatch;
            })" 
            :key="r.id"
            class="rota-card-selecao p-3 mb-2 rounded cursor-pointer transition"
            :class="rotaDestinoId === r.id ? 'bg-success text-white' : 'bg-light'"
            @click="rotaDestinoId = r.id"
            style="border: 1px solid #ccc;"
          >
            <div class="font-bold">#{{ r.id }} - {{ r.nome }}</div>
            <div class="text-sm mt-1" v-if="r.id_tecnico_responsavel" :style="rotaDestinoId === r.id ? 'color: #fff;' : 'color: #666;'">
              Resp: {{ r.nome_tecnico_responsavel || 'Técnico ' + r.id_tecnico_responsavel }}
            </div>
            <div class="text-sm mt-1" v-else :style="rotaDestinoId === r.id ? 'color: #eee;' : 'color: #999;'">
              Sem responsável
            </div>
          </div>
        </div>
      </div>
      
      <vs-row vs-type="flex" vs-justify="center" class="mt-5">
        <vs-button 
          color="success" 
          type="filled" 
          :disabled="!rotaDestinoId" 
          @click="transferirOs()"
          class="w-full"
        >
          TRANSFERIR
        </vs-button>
      </vs-row>
    </vs-popup>

    <!-- Modais Originais -->
    <vx-card class="mt-1" no-shadow card-background="dark">
      <vs-row
        vs-type="flex"
        class
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-w="12"
      >
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="flex-start"
          vs-w="1"
          class
        >
          <excelOs :rotas="rotasLista" :filtro="filtro" @noData="noData">
            <b style="font-size: 16px">Excel</b>
          </excelOs>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="flex-start"
          vs-w="6"
          class
        >
          <vs-col vs-w="4" vs-justify="flex-end" vs-align="flex-end">
            <div class="mt-1 mx-2">
              <b-form-file
                placeholder="Escolha um Arquivo"
                id="file-small"
                size="md"
                @change="previewFiles"
              ></b-form-file>
            </div>
          </vs-col>
          <vs-button
            icon="add"
            :disabled="isPastDate"
            @click="associarComArquivo"
            color="primary"
            type="line"
            size="small"
          >
            <b style="font-size: 16px">Associar com arquivo</b>
          </vs-button>
          <vs-button
            icon="add"
            :disabled="isPastDate"
            @click="desassociar"
            color="danger"
            type="line"
            size="small"
          >
            <b style="font-size: 16px">Desassociar rotas do dia</b>
          </vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>
<script>
import rotaListaOsAssoc from "./rotaListaOsAssoc.vue";
import draggable from "vuedraggable";
import components from "@/components/default/exports.js";
import VisualizarCliente from "./../cliente/visualizar.vue";
import excelOs from "./components/excelOs";
import { getOsPrioridadeMeta } from "@/constants/osPrioridade.js";

export default {
  data() {
    return {
      turnos: [
        { id: null, nome: "Nenhum" },
        { id: 1, nome: "Manhã" },
        { id: 2, nome: "Almoço" },
        { id: 3, nome: "Tarde" },
        { id: 4, nome: "Noite" },
        { id: 5, nome: "Madrugada" },
      ],
      cardClass: "os-card overflow-hidden",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
      filtro: {
        dataHoje: this.$formartData.dataFiltro(),
        data: null,
        turnos: [],
        ordenarPor: null,
        id_contrato: null,
        id_servico: null,
      },
      file: null,
      osAssociar: [],
      osAssociarLista: [],
      osAssociarListaCount: 2,
      osRota: [],
      osRotaOriginal: [],
      rota: [],
      reRender: 1,
      blockButton: false,
      rotasLista: [],
      historicoRotas: [],
      zonas: [],
      controles: [],
      tipos_servico: [],
      isDragging: false,
      highlightRotas: false,
      painelRotasTick: 0,
      
      // Transferência de OS
      isTransferMode: false,
      selectedOsToTransfer: [],
      modalTransferirVisivel: false,
      rotaDestinoId: null,
      buscaRotaDestino: "",
    };
  },
  async mounted() {
    this.filtro.data = this.$formartData.dataFiltro();
    this.filtro.ordenarPor = null;

    // Pré-preenche filtro via query params da URL (ex: vindo do contrato)
    const query = this.$route ? this.$route.query : {};
    if (query.id_servico) {
      this.filtro.id_servico = query.id_servico;
      this.filtro.data = null; // remove filtro de data para encontrar a OS independente do dia
    }
    if (query.id_contrato) {
      this.filtro.id_contrato = query.id_contrato;
    }

    await this.getOsAssociar();
    this.painelRotasTick += 1;
    await this.getZonas();
    await this.getControles();
    await this.getTiposServico();
  },
  computed: {
    isPastDate() {
      if (!this.filtro.data) return false;
      return this.filtro.data < this.filtro.dataHoje;
    },
  },
  methods: {
    async irParaData(offsetDias) {
      const dataBase = new Date();
      dataBase.setDate(dataBase.getDate() + offsetDias);
      const ano = dataBase.getFullYear();
      const mes = String(dataBase.getMonth() + 1).padStart(2, "0");
      const dia = String(dataBase.getDate()).padStart(2, "0");
      this.filtro.data = `${ano}-${mes}-${dia}`;
      await this.filtrar();
    },
    getOsPrioridade(id) {
      return getOsPrioridadeMeta(id);
    },
    previewFiles(event) {
      this.file = event.target.files[0];
    },
    async associarComArquivo() {
      this.$vs.loading();
      try {
        let formData = new FormData();
        formData.append("file", this.file);
        const resposta = await this.$http.post(
          "osAssociarRotaComArquivo",
          formData
        );
        await this.getOsAssociar();
        await this.getOsByRota();
        this.painelRotasTick += 1;
        this.notificarResumoImportacao(resposta);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      this.$vs.loading.close();
    },
    notificarResumoImportacao(resposta) {
      // Backend responde no envelope ApiResponse: { success, message, data: { totalLinhas, associadas, semRota } }
      if (resposta && resposta.success === false) {
        this.$vs.notify({
          title: "Falha na importação",
          text: resposta.message || "Não foi possível processar a planilha.",
          color: "danger",
          icon: "error",
          position: "top-right",
          time: 15000,
        });
        return;
      }
      const resumo = (resposta && resposta.data) || resposta || {};
      const totalLinhas = Number(resumo.totalLinhas) || 0;
      const associadas = Number(resumo.associadas) || 0;
      const semRota = Number(resumo.semRota) || 0;
      const temSemRota = semRota > 0;

      let text =
        `Linhas processadas: ${totalLinhas} | ` +
        `Associadas com sucesso: ${associadas} | ` +
        `Sem rota na planilha: ${semRota}`;
      if (temSemRota) {
        text += ". Essas OS precisarão de associação manual.";
      }

      this.$vs.notify({
        title: temSemRota
          ? "Importação concluída com pendências"
          : "Importação concluída",
        text,
        color: temSemRota ? "warning" : "success",
        icon: temSemRota ? "warning" : "check_circle",
        position: "top-right",
        time: temSemRota ? 15000 : 8000,
      });
    },
    async salvarOrdem() {
      for (let i in this.osRota) {
        this.osRota[i].ordem = i;
      }
    },
    async osAssociarRota() {
      this.$vs.loading();
      let id = this.rota.id;
      try {
        await this.salvarOrdem();
        await this.$http.post("osAssociarRota", { osRota: this.osRota, id });
        this.osRotaOriginal = this.osRota;
        this.osAssociar = await this.$http.post(`getOsAssociar`, this.filtro);
        this.osAssociarLista = this.osAssociar; //.slice(0, 10);
        this.painelRotasTick += 1;
        this.$vs.notify(this.$notify.Success);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      this.$vs.loading.close();
    },
    async getOsAssociar() {
      await this.$vs.loading({ container: "#osAssociar", scale: 0.6 });
      try {
        this.osAssociar = await this.$http.post(`getOsAssociar`, this.filtro);
        this.osAssociarLista = this.osAssociar; //.slice(0, 10);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#osAssociar > .con-vs-loading");
    },
    async getOsAssociarHistorico() {
      await this.$vs.loading({ container: "#osAssociar", scale: 0.6 });
      try {
        this.historicoRotas = await this.$http.post(
          "getOsAssociarHistorico",
          this.filtro
        );
        this.rotasLista = this.historicoRotas;
        this.osAssociar = [];
        this.osAssociarLista = [];
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#osAssociar > .con-vs-loading");
    },
    async rotaSelecionada(rota) {
      this.rota = rota;
      await this.getOsByRota();
    },
    async getOsByRota() {
      if (this.rota == null || this.rota.id == null) {
        this.osRota = [];
        this.osRotaOriginal = [];
        this.reRender = this.reRender + 1;
        return;
      }
      if (this.isPastDate) {
        const rotaHistorico = this.historicoRotas.find(
          (r) => r.id === this.rota.id
        );
        this.osRota = rotaHistorico ? [...rotaHistorico.os] : [];
        this.osRotaOriginal = this.osRota;
        this.reRender = this.reRender + 1;
        return;
      }
      await this.$vs.loading({ container: "#osRota", scale: 0.6 });
      try {
        this.osRota = await this.$http.post(
          `getOsByRota/` + this.rota.id,
          this.filtro
        );
        this.osRotaOriginal = this.osRota;
        this.reRender = (await this.reRender) + 1;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#osRota > .con-vs-loading");
      }
    },
    async showMoreOs2Assoc() {
      return 0;
      if (
        this.osAssociar.length > 10 &&
        this.osAssociar.length > this.osAssociarLista.length
      ) {
        this.$vs.loading();
        await setTimeout(() => {
          this.osAssociarLista = this.osAssociar.slice(
            0,
            10 * this.osAssociarListaCount
          );
          this.osAssociarListaCount += 1;
          this.$vs.loading.close();
        }, 200);
      }
    },
    async filtrarOrdenarPorPrioridade() {
      this.filtro.ordenarPor = "prioridade";
      await this.filtrar();
    },
    async filtrar() {
      this.blockButton = true;
      try {
        if (this.isPastDate) {
          await this.getOsAssociarHistorico();
        } else {
          await this.getOsAssociar();
        }
        this.painelRotasTick += 1;
        if (this.rota.id != null) {
          await this.getOsByRota();
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.blockButton = false;
        this.$vs.loading.close();
      }
    },
    async getZonas() {
      try {
        this.zonas = await this.$http.get(`zona`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getControles() {
      try {
        this.controles = await this.$http.get("controle");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async desassociar() {
      this.$vs.loading();

      try {
        await this.$http.post("desassociar_rotas", this.filtro);
        await this.getOsAssociar();
        await this.getOsByRota();
        this.painelRotasTick += 1;
      } catch (err) {
        const error = this.$httpErrors(err);
        if (err.response && err.response.data) {
          if (err.response.data.message) {
            error.text = err.response.data.message;
          } else if (
            Array.isArray(err.response.data) &&
            err.response.data.length > 0 &&
            err.response.data[0].message
          ) {
            error.text = err.response.data[0].message;
          }
        }
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.$vs.loading.close();
      }
    },
    async exportToExcel() {
      if (!this.$atividades.podeExportar('rota')) return;
      try {
        import("@/vendor/Export2Excel").then(async (excel) => {
          let headerTitle = [
            "ID ROTA",
            "OS",
            "ID CONTRATO",
            "PRIORIDADE",
            "TECNICOS EXECUÇÃO",
            "TURNO",
            "HORA MARCADA",
            "NOME CLIENTE",
            "TIPO SERVIÇO",
            "CONTROLE",
            "HORAS EXECUÇÃO",
            "BAIRRO",
            "PESSOA CONFIRMAÇÃO",
            "ENDEREÇO COMPLETO",
            "OBS",
            "CONFIRMADO",
            "EXECUTADO",
            "TEC.INTEGRADOS",
            "VEICULO",
            "CIDADE",
            "SEGMENTO",
          ];
          let headerVal = [
            "id_rota",
            "id",
            "id_contrato",
            "id_nivel_prioridade",
            "tecnicos_exec",
            "turno",
            "hora_marcada",
            "nomeCliente",
            "tipo",
            "controle",
            "horas_exec",
            "nomeBairro",
            "pessoa_confirmacao",
            "endereco",
            "obs",
            "msg_confirmado",
            "executado",
            "tecnicos_integrados",
            "veiculo",
            "nomeCidade",
            "nomeSegmento"
          ];
          const date = await this.$formartData.formatar(new Date());
          const list = this.osAssociarLista;
          const data = await this.formatJson(headerVal, list);

          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: `OS_${date}`,
            autoWidth: false,
            bookType: "xlsx",
          });
        });
        this.$vs.loading.close();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    async getTiposServico() {
      try {
        this.tipos_servico = await this.$http.get("os_tipos");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async noData() {
      this.$vs.notify({
        title:
          this.filtro.turnos > 0
            ? "Sem Dados para Inserir no Excel!"
            : "Selecione um Turno",
        text: "Use o Filtro para Encontrar Serviços",
        color: "danger",
      });
    },
    async rotaEmit(rotas) {
      this.rotasLista = await rotas;
    },
    onDragStart() {
      this.isDragging = true;
      document.body.classList.add("is-dragging");
    },
    onDragEnd() {
      this.isDragging = false;
      document.body.classList.remove("is-dragging");
    },
    flashRotas() {
      if (this.highlightRotas) return;
      this.highlightRotas = true;
      setTimeout(() => {
        this.highlightRotas = false;
      }, 1200);
    },
    cancelTransferMode() {
      this.isTransferMode = false;
      this.selectedOsToTransfer = [];
    },
    selectAllTransfer() {
      this.selectedOsToTransfer = this.osRota.filter(os => os.executado == null).map(os => os.id);
    },
    openDestinationModal() {
      if (this.selectedOsToTransfer.length === 0) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione pelo menos uma OS pendente para transferir.",
          color: "warning",
          icon: "warning"
        });
        return;
      }
      this.rotaDestinoId = null;
      this.modalTransferirVisivel = true;
    },
    async transferirOs() {
      if (!this.rotaDestinoId || this.selectedOsToTransfer.length === 0) return;
      
      this.$vs.loading();
      try {
        const res = await this.$http.post('rota/transferir-os', {
          osIds: this.selectedOsToTransfer,
          idRotaDestino: this.rotaDestinoId
        });
        
        this.$vs.notify({
          title: "Sucesso",
          text: `OS transferidas com sucesso! (${res.data.transferidas} registros)`,
          color: "success"
        });
        
        this.modalTransferirVisivel = false;
        this.cancelTransferMode();
        
        // Recarregar OS da rota atual
        await this.getOsByRota();
        
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  components: {
    ...components,
    draggable,
    rotaListaOsAssoc,
    VisualizarCliente,
    excelOs,
  },
};
</script>
<style scoped lang="scss">
.list-item {
  background-color: #fff;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
}
.list-item:hover {
  background: #dcdcdc;
}
.active-list-item {
  background-color: #000a12;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
  color: #ffca00;
}
.os-card {
  transition-duration: 50ms;
  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    background-color: #eeeeee;
    color: black;
    cursor: pointer;

    .grid-view-img {
      opacity: 0.9;
    }
  }
}

/* Área de serviços pendentes bloqueada quando sem rota */
.drag-blocked {
  cursor: not-allowed !important;

  .os-card {
    cursor: not-allowed !important;
    user-select: none !important;
  }

  /* Links e componente VisualizarCliente continuam clicáveis */
  a,
  .visualizar-cliente-link {
    pointer-events: auto !important;
    cursor: pointer !important;
    position: relative;
    z-index: 2;
  }
}

.scroll-os-assoc {
  height: 70vh !important;
}

/* Banner de aviso - selecione uma rota */
.rota-nao-selecionada-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  color: #856404;
  font-size: 0.85rem;
  padding: 7px 14px;
  margin: 8px 10px 4px 10px;
  cursor: default;
}

/* Pulsa o outline da coluna de rotas para chamar atenção */
@keyframes pulse-rota {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 193, 7, 0);
    border-radius: 8px;
  }
  30% {
    box-shadow: 0 0 0 5px rgba(255, 193, 7, 0.7);
    border-radius: 8px;
  }
  70% {
    box-shadow: 0 0 0 5px rgba(255, 193, 7, 0.7);
    border-radius: 8px;
  }
  100% {
    box-shadow: 0 0 0 0px rgba(255, 193, 7, 0);
    border-radius: 8px;
  }
}

.highlight-rota-col {
  animation: pulse-rota 1.2s ease-in-out;
}

/* ── Drag & Drop cursors ── */
.draggable-source .os-card {
  cursor: grab !important;

  &:active {
    cursor: grabbing !important;
  }
}

.draggable-target {
  min-height: 40px;
}

.draggable-target.dragging-over .os-card {
  cursor: cell !important;
}

/* ── Badges com ícone ── */
.os-badges-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  width: 100%;
  padding-top: 2px;
}

.os-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 999px;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.badge-success {
  background: #d1fae5;
  color: #065f46;
}
.badge-danger {
  background: #fee2e2;
  color: #991b1b;
}
.badge-warning {
  background: #fef3c7;
  color: #92400e;
}
.badge-dark {
  background: #1e293b;
  color: #f1f5f9;
}
.badge-priority-high {
  background: #fee2e2;
  color: #7f1d1d;
}
.badge-priority-med {
  background: #fef9c3;
  color: #713f12;
}
.badge-priority-low {
  background: #f1f5f9;
  color: #1e293b;
}
/* Escada: laranja queimado — indica risco físico de altura */
.badge-escada {
  background: #ffedd5;
  color: #9a3412;
}
/* FOG: azúul fumo — remete a nuvem/vapor */
.badge-fog {
  background: #e0f2fe;
  color: #075985;
}
/* UBV: violeta água — ultra baixo volume, gotícula fina */
.badge-ubv {
  background: #ede9fe;
  color: #5b21b6;
}
</style>

<style lang="scss">
/* Global: garante cursor grabbing no ghost element e durante todo o drag */
body.is-dragging,
body.is-dragging * {
  cursor: grabbing !important;
}

body.is-dragging .draggable-target *,
body.is-dragging .dragging-over * {
  cursor: cell !important;
}
</style>
